import * as React from 'react';

function EverythingIcon(props) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M3 17l2 2 4-4M3 7l2 2 4-4m4 1h8m-8 6h8m-8 6h8'
				stroke='#545454'
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default EverythingIcon;
